import { Audit } from '../../auth';
import { WorkspaceRoutine } from './workspaceRoutine';

export interface AssetRoutine extends Audit {
  data: any;
  routine: WorkspaceRoutine;
  routineVersion: WorkspaceRoutine;
  exceptionCount?: number;
  id?: string;
}

export interface AssetRoutines {
  count: number;
  items: AssetRoutine[];
}
